import { applyDecorators } from '@nestjs/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsJWT, IsOptional } from 'class-validator';

import { INVALID_TOKEN } from '../constants';
import { BaseDecoratorOptions } from '../types';

export function ApiPropertyJwt({ isOptional, ...options }: BaseDecoratorOptions<string> = {}): PropertyDecorator {
  const propertyOptions = {
    type: String,
    ...options,
  };

  return applyDecorators(
    ...(isOptional ? [IsOptional(), ApiPropertyOptional(propertyOptions)] : [ApiProperty(propertyOptions)]),
    IsJWT({ message: INVALID_TOKEN }),
  );
}
